import React from "react";

const TrianglesOxiRow = () => {
const colors = [
    { color: "#a92a41", label: "Hipoxia,\nModerada"},
    { color: "#48457c", label: "Hipoxia,\nLeve"},
    { color: "#1983c4", label: "Normal"},
 
  
  ];


  const triangleSize = 7;
  const triangleHeight = (Math.sqrt(3) / 2) * triangleSize; // Altura de los triangulos

  return (
    <svg width="100%" height={triangleHeight + 40} xmlns="http://www.w3.org/2000/svg">
      {colors.map((item, index) => (
        <g key={index}>
          <polygon
            points={`${index * 100 + 50 + index * 5 + 9 + (index < 3 ? 5 : 0)} ,${0} ${(index * 100 + 50 + index * 5 + 9 + (index < 3 ? 5 : 0)) - triangleSize / 2},${triangleHeight + 0} ${(index * 100 + 50 + index * 5 + 9 + (index < 3 ? 5 : 0)) + triangleSize / 2},${triangleHeight + 0}`}
            fill={item.color}
            letterSpacing="2"
          />
          <text
            x={`${index * 49.5 + 10 + index * 5 + 9 + (index < 3 ? 5 : 0)}`}
            y={triangleHeight - 1}
            textAnchor="middle"
            dominantBaseline="middle"
            fill={item.color}
            fontSize="10"
            fontWeight="bold"
            style={{
              maxWidth: "60px",
              whiteSpace: "pre-line",
            }}
          >
            {item.label.split("\n").map((line, i) => (
              <tspan key={i} x={`${index * 100 + 50 + index * 5 + 9 + (index < 3 ? 5 : 0)}`} dy="1em">
                {line}
              </tspan>
            ))}
          </text>
        </g>
      ))}
    </svg>
  );
};


export default TrianglesOxiRow;
